module.exports = __webpack_public_path__ + "static/img/birds-footer.8ee50ec4.svg";